/**
 * Format numbers with proper locale support for Arabic and English
 */

export const formatNumber = (num: number, language: 'ar' | 'en' = 'en', options?: Intl.NumberFormatOptions): string => {
  const locale = language === 'ar' ? 'ar-SA' : 'en-US';
  
  const defaultOptions: Intl.NumberFormatOptions = {
    maximumFractionDigits: 2,
    ...options
  };
  
  return num.toLocaleString(locale, defaultOptions);
};

/**
 * Format currency with proper locale and SAR symbol
 */
export const formatCurrency = (amount: number, language: 'ar' | 'en' = 'en'): string => {
  const formattedAmount = formatNumber(amount, language);
  return language === 'ar' 
    ? `${formattedAmount} ريال` 
    : `${formattedAmount} SAR`;
};

/**
 * Format percentage with proper locale
 */
export const formatPercentage = (value: number, language: 'ar' | 'en' = 'en'): string => {
  const formatted = formatNumber(value, language, { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  return `${formatted}%`;
};
